import React from 'react';

import Tag from '../shared/Tag';

const DisplaySelectLabel = ({ value }) => {
    return (
        <div className='tag-container'>
            <Tag label={value.name} />
        </div>
    );
};

export default DisplaySelectLabel;
